export default "__VITE_ASSET__98101f16__"